<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>客户管理
      <i class="el-icon-arrow-right"></i>&nbsp;套餐购买记录
    </div>

    <div class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-form :inline="true" label-width="120px">
        <div class="item-wrapper">

          <div class="item-content clearfix">
            <el-form-item label="客户名称" style="margin-bottom: 0px;">
              <el-select v-model="tenantId" @change="getPurchasedResourcePackages" placeholder="请选择" style="width: 320px;">
                <el-option
                  v-for="item in cusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.username">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

        </div>
      </el-form>
    </div>

    <section class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-table
        :data="tableData.data"
        v-loading="loading"
        stripe
        style="width: 100%">
        <el-table-column
          prop="productName"
          label="产品名称"
          :width="150*navCollapse">
        </el-table-column>

        <el-table-column
          prop=""
          label="类型"
          :width="100*navCollapse">
          <template slot-scope="scope">
            {{scope.row.purchaseType == 1 ? '新购' : (scope.row.purchaseType == 2 ? '续购' : (scope.row.purchaseType == 3 ? '升级' : '增购License'))}}
          </template>
        </el-table-column>

        <el-table-column
          prop=""
          label="720P图像数量（张/月）"
          :width="180*navCollapse">
          <template slot-scope="scope">
            {{scope.row.tokenNumber/1348}}
          </template>
        </el-table-column>

        <!--        <el-table-column-->
        <!--          prop=""-->
        <!--          label="Token数量（万个）"-->
        <!--          :width="150*navCollapse">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{formattedPrice(scope.row.tokenNumber/10000)}}-->
        <!--          </template>-->
        <!--        </el-table-column>-->

                <el-table-column
                  prop="maxQps"
                  label="QPS"
                  :width="150*navCollapse">
                </el-table-column>

        <el-table-column
          prop=""
          label="有效时长"
          :width="100*navCollapse">
          <template slot-scope="scope">
            {{scope.row.duration}}{{scope.row.durationType === 1 ? '天':'月'}}
          </template>
        </el-table-column>

        <el-table-column
          prop="updateTime"
          label="购买时间"
          :width="170*navCollapse">
        </el-table-column>

        <el-table-column
          prop=""
          label="到期日期"
          :width="120*navCollapse">
          <template slot-scope="scope">
            {{scope.row.expireTime.slice(0,10)}}
          </template>
        </el-table-column>

        <el-table-column
          prop="licenseCount"
          label="License数量"
          :width="120*navCollapse">
        </el-table-column>

        <el-table-column
          prop="settlementFee"
          label="结算金额（元）"
          :width="120*navCollapse">
        </el-table-column>

        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openResourceDialog(scope.row)" >套餐信息</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>

    </section>

    <el-dialog v-if="cusOrderDetail.paramPicture" title="套餐信息" :visible.sync="dialogResourceVisible" width="70%">
      <div style="margin: 10px 0px; font-size: 16px; font-weight: bold;">资源规格</div>
      <div class="my-table" style="width: 66vw; ">
        <div>
          <div class="table-header">
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">套餐名称</span>
            <span class="table-cell" style="width: 18vw;">套餐规格</span>
            <span class="table-cell" style="width: 8vw;">License数量</span>
            <span class="table-cell" style="width: 8vw;">有效时长</span>
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">单价（元/License）</span>
            <span class="table-cell" style="width: 8vw;">总价（元）</span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;">
        </div>

        <div>
          <div class="table-row">
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">{{cusOrderDetail.paramPicture.name}}</span>
            <span class="table-cell" style="width: 18vw;">{{cusOrderDetail.paramPicture.spec}}</span>
            <span class="table-cell" style="width: 8vw;">{{cusOrderDetail.orderDetail.licenseCount}}</span>
            <span class="table-cell" style="width: 8vw;">{{cusOrderDetail.orderDetail.duration}}{{cusOrderDetail.orderDetail.durationUnit === '天' ? '天' : '个月'}}</span>
            <span class="table-cell" style="margin-left: 2vw; width: 8vw; color: #EF6234; ">{{formattedPrice(cusOrderDetail.orderDetail.unitPrice/100)}}</span>
            <span class="table-cell" style="width: 8vw; color: #EF6234; font-weight: bold; font-size: 16px;">
                  {{formattedPrice(cusOrderDetail.orderInfo.realPrice/100)}}
            </span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogResourceVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

  </main>
</template>

<style>
.el-table .success-cell {
  background: #F0F9EB;
  font-weight: bold;
}
</style>

<script>
import {mapState} from 'vuex'

import {
  reqProductQuotaRecords,
  reqCusOrderDetail,
  reqFindAllCustomers
} from '@/api'

export default {
  name: 'AllPurchasedResourcePackage',

  data() {
    return {
      cusList: [],
      tenantId: '',
      tableData: {},
      loading: true,

      dialogResourceVisible: false,
      purchaseType: 0,
      cusOrderDetail: {},

      currentPage: 1,
      total: 0,
      pageSize: 15
    }
  },

  async mounted() {
    await this.findAllCustomers()
    await this.getPurchasedResourcePackages()
  },

  methods: {
    async findAllCustomers() {
      const result = await reqFindAllCustomers('', this.currentPage)
      if (result.code === 0) {
        this.cusList = result.data.list
        this.tenantId = this.cusList[0].username
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    formattedPrice (num) {
      return parseFloat(parseFloat(num).toFixed(2)) // 保留两位小数
    },

    formattedInt (num) {
      return parseInt(parseInt(num).toFixed(0))
    },

    async getPurchasedResourcePackages() {
      this.loading = true
      const result = await reqProductQuotaRecords('/product/getUpdateQuotaRecord', this.tenantId, this.purchaseType, this.currentPage, this.pageSize)
      if (result.code === 200) {
        this.tableData = result.data
        this.loading = false
        this.total  = result.data.total
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async openResourceDialog(row) {
      const result = await reqCusOrderDetail(row.orderId)
      if (result.code === 0) {
        this.cusOrderDetail = result.data
        this.dialogResourceVisible = true
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async handleCurrentChange(val) {
      this.currentPage = val
      await this.getProduct()
    },

  },

  computed: {
    ...mapState(['navCollapse', 'wrapperWidth']),
  }

}
</script>

<style scoped>

main {
  /*width: 100%;*/
  display: flex;
  flex-direction: column;
}

.content_wrapper {
  width: 82vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
}

.tip-ol-box {
  background-color: rgba(96, 149, 242, 0.3);
  padding: 10px 0px;
}

.tip-ol {
  color: #0C129A;
  font-size: 12px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminCenter/AllPurchasedResourcePackage/AllPurchasedResourcePackage.vue